import { Box, useTheme, useMediaQuery } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { toCurrency, toPercent, toCurrencyWholeNumber } from "@helpers";
import { InvestmentsChartDataStatistic } from "@api/v1/hooks/performance/useInvestmentsChartData";
import { MandatorTypography } from "@components/MandatorTypography";
import {
  SummaryItem,
  MarketValueContentBox,
  GainLossPercentsStyled,
} from "./components";

export interface InvestmentsTableSummaryMobileProps {
  statistic: InvestmentsChartDataStatistic;
}

export const InvestmentsTableSummaryMobile = ({
  statistic,
}: InvestmentsTableSummaryMobileProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      width="100%"
      sx={{
        display: "grid",
        gridTemplateColumns: "repeat(2, 1fr)",
        gap: "14px",
      }}
    >
      <SummaryItem label={t("investmentsTable.summary.today")}>
        <Box display="flex" flexDirection={isSm ? "column" : "row"} gap={1}>
          <MandatorTypography variant="subtitle2">
            {toCurrency(statistic.changeTodayAbs, "EUR")}
          </MandatorTypography>
          <MandatorTypography variant="subtitle2">
            ({toPercent(statistic.changeToday)})
          </MandatorTypography>
        </Box>
      </SummaryItem>
      <SummaryItem label={t("investmentsTable.summary.purchaseValue")}>
        <MandatorTypography variant="subtitle2">
          {toCurrency(statistic.investedCapital, "EUR")}
        </MandatorTypography>
      </SummaryItem>
      <SummaryItem label={t("investmentsTable.summary.priceGains")}>
        <MandatorTypography variant="subtitle2">
          {toCurrency(statistic.valuationGain, "EUR")}
        </MandatorTypography>
      </SummaryItem>
      <SummaryItem label={t("investmentsTable.summary.marketValue")}>
        <MarketValueContentBox>
          <MandatorTypography variant="subtitle2" noWrap>
            {toCurrencyWholeNumber(statistic.portfolioValue, "EUR")}
          </MandatorTypography>
          <GainLossPercentsStyled value={statistic.valuationGainPercent ?? 0} />
        </MarketValueContentBox>
      </SummaryItem>
    </Box>
  );
};
